import React from 'react';
import benchmarks from "../data/benchmarks.json";

class GlobalAverages extends React.Component {
  render() {
    if (this.props.data === null) {
      return (
        <div className="global">
          <p>Loading...</p>
        </div>
      )
    } else {
      function roundScore(score) {
          const numScore = parseFloat(score);
          return Math.round(numScore * 100);
      }

      const averages = this.props.data;
      const globalScore = Object.keys(averages).map(function(testType) {
          const chartValue = roundScore(averages[testType]);
          const chartLabel = testType;
          const chartIndex = testType;
          const benchmark = roundScore(benchmarks[testType]);

          // Don't show progessive web app score.
          if (chartLabel === 'pwa') {
              return false;
          }

          let scoreClass = 'score-red'
          if (chartValue >= benchmark) {
              scoreClass = 'score-green';
          }

          let scoreLabel = "";
          if (chartLabel === "performance") {
              scoreLabel = "Perf";
          }
          else if (chartLabel === "best-practices") {
              scoreLabel = "BP";
          }
          else if (chartLabel === "accessibility") {
              scoreLabel = "A11y";
          }
          else if (chartLabel === "seo") {
              scoreLabel = "SEO";
          }


          return <div key={chartIndex} className="score"><span className={scoreClass}>{chartValue}<br/><span className="score-label">{scoreLabel}</span></span><div className="benchmark"><span className="title">Goal:</span> {benchmark}</div></div>
      });

      return (
          <div className="percentage-pass">
              <p>Global average (rolling 30 days)</p>
              <div className="scores">
                  {globalScore}
              </div>
          </div>
      );
    }
  }
}

export default GlobalAverages;